const BASE_API = process.env.REACT_APP_ROUTE_API;
const token = localStorage.getItem('token');
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    listar: async () => {
        try {
          const req = await fetch(`${BASE_API}site/municipios`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? [];
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return(error);
        }
      },
};